<template>
  <div>
    <base-header type class="rsgradient pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row" v-if="model.isCommerce == true || model.isAssociatedCommerce || model.isCashier &&  model.showTotalOperatedCashier">
        <div class="col-xl-12 col-lg-12">
          <stats-card
            v-bind:title="model.titleSaldo"
            type="gradient-green"
            v-bind:sub-title="model.saldo"
            icon="ni ni-money-coins"
            class="mb-4 mb-xl-0"
          >
            <!-- <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-search"></i></span>
                            <a href="/ctacte" class="text-nowrap">Ver detalle</a>
            </template>-->
            <template slot="footer" v-if="model.isCommerce || model.isAssociatedCommerce">
              <div
                style="font-weight:bold;cursor: pointer;"
                @click="toggleShowBalance()"
              >{{model.formattedAmountToCredit}} a liquidar            
                      <i :class="model.hideBalanceIcon"></i>
              </div>
            </template>
          </stats-card>
                           <div style="font-size:10px;  position: fixed;
            bottom: 0; padding:10px">RESIMPLE ofrece servicios de pago y no es una entidad financiera ni se encuentra
autorizado a operar como entidad financiera por el Banco Central de la República
Argentina. RESIMPLE no presta al Usuario ningún servicio bancario o cambiario. Los
fondos depositados en la cuenta de pago no constituyen depósitos en una entidad
financiera, ni cuentan con ninguna de las garantías que tales depósitos puedan gozar
de acuerdo con la legislación y reglamentación aplicables en materia de depósitos de
entidades financieras.</div>
        </div>
      </div>
    </base-header>
  </div>
</template>
<script>
// Charts
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import firebase from "firebase/app";
import {
  initializeFirebase,
  askForPermissioToReceiveNotifications
} from "../push-notification";

// Tables
import SocialTrafficTable from "./Dashboard/SocialTrafficTable";
import PageVisitsTable from "./Dashboard/PageVisitsTable";
import store from "/src/store.js";

import { mapActions, mapGetters } from "vuex";
import axiosHelpers from "@/helpers/axiosHelpers";

import notificationHelpers from "@/helpers/notificationHelpers";

import KitsBusqueda from "@/components/KitsBusqueda";

export default {
  components: {
    LineChart,
    BarChart,
    PageVisitsTable,
    SocialTrafficTable,
    KitsBusqueda
  },
  data() {
    return {
      model: {
        isCommerce: false,
        isAssociatedCommerce: false,
        isCashier: false,
        showTotalOperatedCashier: false,
        titleSaldo: "",
        originSaldo: "",
        saldo: "",
        amountToCredit: 0,
        originFormattedAmountToCredit: "",
        formattedAmountToCredit: "",
        cuenta: null,
        hideBalance: false,
        hideBalanceIcon: "",
      }
    };
  },
  methods: {
    changeHideBalanceIcon() {
      this.model.hideBalanceIcon = this.model.hideBalance ? 'fas fa-eye-slash' : 'fas fa-eye';
      this.model.formattedAmountToCredit = this.model.hideBalance ? '*****' : this.model.originFormattedAmountToCredit;
            this.model.saldo = this.model.hideBalance ? '*****' : this.model.originSaldo;
    },
     toggleShowBalance() {
      let context = this;

      axiosHelpers.axiosPost("Account/ChangeAccountHideBalance", {}, this, function(data) {

        if (data.ResponseVM.Success) {
            context.model.hideBalance = !context.model.hideBalance;
            context.changeHideBalanceIcon();
        }
      });
    },
    getCredit() {
      let context = this;
      axiosHelpers.axiosGet("Home/GetHome", {}, this, function(data) {
        if (context.model.isCashier) {
          context.model.saldo = data.ResponseVM.FormattedLastOperationsAmount;
        } else {
          context.model.saldo = data.ResponseVM.FormatedCredit;
        }
        context.model.originSaldo = context.model.saldo;
        context.model.amountToCredit = data.ResponseVM.AmountToCredit;
        context.model.originFormattedAmountToCredit = data.ResponseVM.FormattedAmountToCredit;
        context.model.formattedAmountToCredit =
          data.ResponseVM.FormattedAmountToCredit;
        context.model.hideBalance = data.ResponseVM.HideBalance;
        context.changeHideBalanceIcon();
        context.$store.dispatch("initCashBoxName", data.ResponseVM.CashBoxName);
      });
    },
    getPermissions() {
      let context = this;

      if (!context.$store.getters.HasPermissions) {
        axiosHelpers.axiosGet(
          "Permission/GetPermissionsForSystem",
          { SystemID: context.$store.getters.SystemaWebAppId },
          this,
          function(data) {
            context.$store.dispatch("initPermissions", data.ResponseVM.Items);
          }
        );
      }
    }
  },
  beforeMount: function() {
    let context = this;

    context.model.isCommerce = store.getters.isCommerce;
    context.model.isAssociatedCommerce = store.getters.isAssociatedCommerce;
    context.model.isCashier = store.getters.isCashier;
    context.model.showTotalOperatedCashier = store.getters.SHOW_TOTAL_OPERATED_CASHIER;

    if (context.model.isCashier) {
      context.model.titleSaldo = "Total Operado";
    } else {
      context.model.titleSaldo = "Saldo actual";
    }

    context.getCredit();
    initializeFirebase();
    askForPermissioToReceiveNotifications(context);
    context.getPermissions();
  },
  mounted: function() {
    const messaging = firebase.messaging();
    messaging.onMessage(payload => {
      console.log("Message received. ", payload);
    });
  }
};
</script>
<style></style>
